export default "__VITE_ASSET__k$hX5gKj__"